/* unplugin-vue-components disabled */import { render } from "./gold_pay_success.vue?vue&type=template&id=25ecd0ca&scoped=true"
import script from "./gold_pay_success.vue?vue&type=script&lang=js"
export * from "./gold_pay_success.vue?vue&type=script&lang=js"

import "./gold_pay_success.vue?vue&type=style&index=0&id=25ecd0ca&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ecd0ca"]])

export default __exports__